import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Keyword } from '@dam/types';

import { DAOService } from './dao-service';
import { environment } from '../../../../../../src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KeywordsService extends DAOService<Keyword> {
  baseUrl = environment.baseUrl + '/api/keywords';

  constructor(protected http: HttpClient) {
    super(http);
  }
}
